import sendings from '@sigma-frontend-libs/messages/es/sendings'

export default {
  title: 'Informe financiero',

  labels: {
    id: 'ID',
    owner: 'Propietario',
    action: 'Acción',
    source: 'Fuente',
    amount: 'Cantidad',
    multiplier: 'Multiplicador',
    comment: 'Comentario',
    preset: 'Preajuste',
    status: 'Estado',
    tariff: 'Tarifa',
    noRef: 'No referible',
    price: 'Precio',
    TariffId: 'Tarifa',
    total: 'Total',
    priceCalculation: 'Cálculo de precio',

    Owner: {
      id: 'Propietario'
    },

    count: {
      pending: 'Pendiente {count}',
      refunded: 'Reembolsado {count}',
      complete: 'Completo {count}',
      invalid: 'Inválido {count}',
      total: 'Total {count}'
    },

    ref: {
      true: 'Referible',
      false: 'No referible',
      undefined: 'No especificado'
    },

    data: {
      price: 'Precio',
      multiplier: 'Multiplicador',

      priceCalculation: {
        price: 'Precio',
        size: 'Tamaño',
        spent: 'Usado',
        counter: 'Contador',
        segmentPrice: 'Precio',
        segmentCount: 'Segmentos',
        threshold: 'Umbral',
        sum: 'Subtotal',

        types: {
          packet: 'Paquete',
          range: 'Rango'
        }
      }
    }
  },

  headers: {
    status: 'Estado',
    owner: 'Propietario',
    creator: 'Creador',
    source: 'Tipo',
    tariff: 'Tarifa',
    comment: 'Comentario',
    amount: 'Cantidad',
    total: 'Total',
    title: 'Título',
    frequency: 'Frecuencia',
    count_pending: 'Pendiente',
    sum_pending: 'Pendiente (suma)',
    count_refunded: 'Reembolsado',
    sum_refunded: 'Reembolsado (suma)',
    count_complete: 'Completo',
    sum_complete: 'Completo (suma)',
    count_invalid: 'Inválido',
    sum_invalid: 'Inválido (suma)',
    count_total: 'Total',
    sum_total: 'Total (suma)',
    referrer: 'Referente'
  },

  dialogs: {
    create: 'Crear una nueva operación de facturación'
  },

  actions: {
    addFunds: 'Agregar fondos',
    charge: 'Retirar fondos'
  },

  hints: {
    date: {
      from: 'AAAA-MM-DD',
      by: 'AAAA-MM-DD'
    },
    time: {
      from: 'HH:MM',
      by: 'HH:MM'
    },
    empty: 'Para obtener datos, utilice el filtro.'
  },

  presets: {
    billings: {
      details: 'Informe detallado de operaciones de facturación',
      group001: 'Agrupación por fuente'
    }
  },

  report: {
    download: 'Descargar',
    get: 'Obtener informe'
  },

  statuses: {
    pending: 'Pendiente',
    refunded: 'Reembolsado',
    complete: 'Completo',
    invalid: 'Inválido'
  },

  buttons: {
    clear: 'Limpiar filtro',
    refresh: 'Actualizar'
  },

  tooltips: {
    refresh: 'Actualiza los datos de la tabla usando el filtro seleccionado.',
    actions: 'Recargar o retirar saldo'
  },

  tabs: {
    billings: 'Informe financiero',
    tasks: 'Tareas'
  },

  sources: {
    ...sendings.types,
    subtract: 'Retiro',
    accrual: 'Recarga'
  },

  snackbars: {
    created: 'Operación de facturación creada con éxito.',
    updated: 'Operación de facturación actualizada con éxito.',
    removed: 'Operación de facturación eliminada con éxito.',
    funds: {
      success: 'Fondos acreditados con éxito.',
      failed: 'Error al acreditar fondos.'
    }
  },

  currency: {
    RUB: '₽ rublos rusos',
    USD: '$ dólares estadounidenses',
    EUR: '€ euros',
    MXN: 'MX$ pesos mexicanos'
  }
}
